module.exports = "/images/6637a1e898873be025ff9459b091bf83.svg";